module.exports = __webpack_public_path__ + "img/avatar-16.5c40676f.png";